// extracted by mini-css-extract-plugin
export default {"root":"gJ3uy9","disablePadding":"lxWkk5","disableGutters":"_d1RBl"};